<template>
  <div class="header-block pb-5 truncate mb-5">
    <h2 class="mb-1 font-bold">
      <router-link :to="'/site/' + slug">{{ title }}</router-link>
    </h2>
    <div class="chart-header">
      <router-link :to="'/site/graph/' + slug">
        <feather-icon icon="EyeIcon" svgClasses="icon" />
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  props: ["title", "slug"],
};
</script>

<style lang="scss" scoped>
.header-block {
  position: relative;
  height: 50px;
}
.chart-header {
  position: absolute;
  right: 0;
  top: 0;
}
</style>
